import { GeoJSON } from "geojson";
import { IClaim, IPolicy } from "@/types";

export interface IBaseAddress {
  building_id?: number;
  address_point_id?: number;
  addr_line_1: string;
  addr_line_2: string;
  addr_line_3: string;
  addr_line_4: string;
  addr_line_5: string;
  addr_line_6: string;
  addr_line_7: string;
  addr_line_8: string;
  addr_line_9: string;
  addr_line_10: string;
  address?: string;
  postcode?: string;
  geom?: GeoJSON.Point;
  matchlevel?: null | number;
  matchresult?: null | number;
}

export class BaseAddress {
  protected _data!: IBaseAddress | IClaim | IPolicy;
  constructor(data: IBaseAddress | BaseAddress) {
    if (data instanceof BaseAddress) {
      return data;
    }
    this._data = data;
  }

  get formattedAddress() {
    return (
      this._data.address ||
      Object.keys(this._data)
        .filter((k) => k.startsWith("addr_line_"))
        .map((k) => this._data[k as keyof IBaseAddress])
        .filter((v) => v)
        .join(", ")
    );
  }

  get postcode(): string | undefined {
    return this._data.postcode;
  }

  get geometry(): GeoJSON.Point | undefined {
    return this._data.geom;
  }

  get buildingId() {
    return this._data.building_id;
  }

  get addressPointId() {
    return this._data.address_point_id;
  }

  get matchResult(): number | null {
    return this._data.matchresult || null;
  }

  get matchLevel(): number | null {
    return this._data.matchlevel || null;
  }

  get coordinates(): number[] {
    return this.geometry?.coordinates || [];
  }
}
